import reusables from '@styles/theme/reusables';
import theme from '@styles/theme';
export default {
  dropdownContainer: {
    position: 'relative'
  },
  button: {
    background: 'none',
    outline: 'none',
    letterSpacing: '0',
    border: 'none',
    position: 'relative',
    height: '32px',
    mr: '10px',
    display: 'inline-flex',
    top: '4px'
  },
  dropdownIcon: (isActive: boolean) => ({
    position: 'absolute',
    display: 'inline-block',
    width: '24px',
    height: '24px',
    right: 0,
    top: 'calc(50% - 2px)',
    transform: isActive ? 'translateY(-50%) rotate(-90deg)' : 'translateY(-50%) rotate(90deg)',
    pointerEvents: 'none',
    ...reusables.mainTransition('transform', 'ease-in-out', '.15s')
  }),
  buttonText: {
    whiteSpace: 'nowrap',
    display: 'inline-block',
    p: '8px 36px 4px 4px',
    lineHeight: '24px',
    position: 'relative',
    bottom: '4px',
    '&::first-letter': {
      textTransform: 'uppercase'
    }
  },
  dropdown: (isActive: boolean) => ({
    minHeight: '50px',
    minWidth: ['220px', '220px', '220px', '220px', '236px'],
    background: '#fff',
    p: '16px',
    mt: '8px',
    right: ['unset', '-50%'],
    position: 'absolute',
    border: `1px solid ${theme.rawColors.lightGrey300}`,
    zIndex: theme.zIndex.documentHigh + 1,
    opacity: isActive ? 1 : 0,
    display: isActive ? 'block' : 'none',
    fontSize: '14px',
    ...reusables.mainTransition('opacity', 'ease-in-out', '5s'),
    '&:before, &:after': {
      position: 'absolute',
      content: '""',
      top: '-10px',
      right: '26px',
      width: 0,
      height: 0
    }
  })
};